export default "__VITE_ASSET__12776507__"